import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { images } from "../../helpers/images";
import { onClickSignin } from "../../modules/actions/";
import { authUserData } from "../../helpers";

class Signin extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      subdomain: "",
      email: "",
      password: "",
      disableSubmit: false,
    };
  }

  componentDidMount() {
    let hostData = window.location.host.split(".");

    /* if (hostData && hostData.length !== 3) {
      window.location.href = "http://saqgenerator.local";
    } */

    this.setState({
      subdomain: hostData[0],
    });

    const userData = authUserData();

    console.log("+++++++++++++++++++ SIGININ");

    /* let businessAdmin;

    if (
      userData &&
      userData.accessToken &&
      userData.userType &&
      userData.busissDetails &&
      userData.busissDetails.length > 0
    ) {
      businessAdmin = userData.busissDetails.filter((v, i) => {
        return v.userType === admin && v;
      });

      console.log("businessAdmin", businessAdmin);
    } */

    /* if() {

    }

    userData &&
      userData.accessToken &&
      userData.userType &&
      userData.userType === "admin" */

    /* if (
      userData &&
      userData.accessToken &&
      userData.userType &&
      userData.userType === "admin"
    ) {
      this.props.history.push("/admin/dashboard");
    } else if (userData && userData.accessToken) {
      this.props.history.push("/dashboard");
    } */
  }

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickSignin = async () => {
    this.setState({ disableSubmit: true });

    const res = await this.props.onClickSignin({
      subdomain: this.state.subdomain,
      email: this.state.email,
      password: this.state.password,
      history: this.props.history,
    });

    setTimeout(() => this.setState({ disableSubmit: false }), 2500);
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickSignin(evt);
    }
  };

  render() {
    const { email, password, disableSubmit } = this.state;

    return (
      <div className="grid-container full">
        <div className="grid-x  grid-margin-x" id="container">
          <div className="cell small-12 medium-5" id="infoplatesection">
            <div id="logosection">
              <img src={images.logo} />
            </div>

            <div id="infotxt">
              A few clicks away <br />
              from creating your SAQ
            </div>

            <div id="infobutton">
              <Link to="/signup">
                <button className="button login" id="registerBtn">
                  Sign up
                </button>
              </Link>
              <p> or </p>{" "}
              <Link to="/signin">
                <button className="button login active" id="loginBtn">
                  Sign in
                </button>
              </Link>
            </div>
            <div style={{ textAlign: "center", marginTop: "35px" }}>
              <Link to="/forgot-password">
                <button
                  style={{
                    color: "#ffffff",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Forgot Password
                </button>
              </Link>
            </div>
          </div>
          <div className="cell small-12 medium-7" id="formsection">
            <div id="loginsaq" className="show">
              <h3>Sign in</h3>
              <p>Manage all your SAQs effeciently</p>
              {/* <p className="smalltxt">
                Let’s get you all setup so you can verify your personal account
                and begin creating SAQ
              </p> */}

              <ToastContainer />

              <div className="grid-container" id="formfieldscontainer">
                <div className="grid-y grid-x">
                  <div className="small-12 medium-8 cell">
                    <label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter email"
                        name="email"
                        value={email}
                        onChange={(evt) => this.onChangeHandelUserInput(evt)}
                        onKeyPress={(evt) => this.onTextKeyPress(evt)}
                      />
                    </label>
                  </div>
                  <div className="small-12 medium-8 cell">
                    <label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password"
                        name="password"
                        value={password}
                        onChange={(evt) => this.onChangeHandelUserInput(evt)}
                        onKeyPress={(evt) => this.onTextKeyPress(evt)}
                      />
                    </label>
                  </div>
                </div>
                <div id="fieldbuttons">
                  <button
                    className="button nxt-btn"
                    onClick={() => this.onClickSignin()}
                    disabled={disableSubmit}
                  >
                    Sign in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickSignin }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
